/*
 * @Author: bill
 * @Date: 2024-05-22 09:20:22
 * @LastEditors: wangzijun@bzstech.com wangzijun@bzstech.com
 * @LastEditTime: 2024-05-23 13:46:09
 * @FilePath: /study/src/store/modules/classification.ts
 * @Description:
 */
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AppThunk } from "../index";

interface IClassificationState {
  moduleBuild: {
    visible: boolean;
    type: number,
    record: any;
  };
}

const initialState: IClassificationState = {
  moduleBuild: {
    visible: false,
    type: 1, // 1新增 2编辑
    record: {},
  },
};

export const classificationSlice = createSlice({
  name: "classification",
  initialState: initialState,
  reducers: {
    setModuleBuild: (state, action: PayloadAction<any>) => {
      state.moduleBuild = action.payload;
    },
  },
});

// 导出action
export const { setModuleBuild } = classificationSlice.actions;

export default classificationSlice.reducer;
